import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';




const ComplianceReportCard = ({ report, onViewDetails, onExport }) => {
  const getVarianceColor = (type) => {
    if (type === 'positive') return 'text-success';
    if (type === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getVarianceIcon = (type) => {
    if (type === 'positive') return 'TrendingUp';
    if (type === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  const getStatusBadge = (status) => {
    const badges = {
      draft: { bg: 'bg-muted', text: 'text-muted-foreground', label: 'Draft' },
      generated: { bg: 'bg-primary/10', text: 'text-primary', label: 'Generated' },
      reviewed: { bg: 'bg-warning/10', text: 'text-warning', label: 'Reviewed' },
      approved: { bg: 'bg-success/10', text: 'text-success', label: 'Approved' },
      submitted: { bg: 'bg-success/20', text: 'text-success', label: 'Submitted' }
    };
    return badges?.[status] || badges?.draft;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString)?.toLocaleDateString('en-PG', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const badge = getStatusBadge(report?.reportStatus);

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 hover:shadow-md transition-smooth">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <h3 className="font-heading font-semibold text-base md:text-lg text-foreground">
              {report?.reportName}
            </h3>
            <span className={`px-2 py-1 ${badge?.bg} ${badge?.text} text-xs font-caption rounded-full`}>
              {badge?.label}
            </span>
          </div>
          <p className="caption text-xs text-muted-foreground mb-1">
            {formatDate(report?.periodStart)} - {formatDate(report?.periodEnd)}
          </p>
          <p className="caption text-xs text-muted-foreground">
            Generated by {report?.generatedBy || 'System'} on {formatDate(report?.generatedAt)}
          </p>
        </div>
        <Icon name="FileText" size={24} color="var(--color-primary)" />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
        <div>
          <p className="caption text-xs text-muted-foreground mb-1">Compliance Score</p>
          <p className="font-heading font-bold text-xl text-foreground">
            {report?.overallComplianceScore?.toFixed(1)}%
          </p>
        </div>
        <div>
          <p className="caption text-xs text-muted-foreground mb-1">Variance</p>
          <div className="flex items-center gap-1">
            <Icon 
              name={getVarianceIcon(report?.varianceType)} 
              size={16} 
              color={getVarianceColor(report?.varianceType)?.replace('text-', 'var(--color-)')} 
            />
            <p className={`font-heading font-bold text-base ${getVarianceColor(report?.varianceType)}`}>
              {report?.variancePercentage > 0 ? '+' : ''}{report?.variancePercentage?.toFixed(2)}%
            </p>
          </div>
        </div>
        <div>
          <p className="caption text-xs text-muted-foreground mb-1">Violations</p>
          <p className="font-heading font-bold text-base text-foreground">
            {report?.totalViolations} <span className="text-error">({report?.criticalViolations} critical)</span>
          </p>
        </div>
        <div>
          <p className="caption text-xs text-muted-foreground mb-1">Employees</p>
          <p className="font-heading font-bold text-base text-foreground">
            {report?.compliantEmployees}/{report?.totalEmployees}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <Button
          variant="default"
          size="sm"
          onClick={() => onViewDetails?.(report?.id)}
          iconName="Eye"
          iconPosition="left"
        >
          View Details
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onExport?.(report?.id)}
          iconName="Download"
          iconPosition="left"
        >
          Export
        </Button>
      </div>
    </div>
  );
};

export default ComplianceReportCard;